<div class="th-menulevel">
  <div class="ir-btn ir-btn--big th-btn-menulevel" (click)="selectMenu(2)">
    <span>{{ 'home.new-inspection' | translate }}</span>
  </div>
  <!--<div class="ir-btn ir-btn--big th-btn-menulevel" (click)="selectMenu(1)">
        <span>New inspection </span>
    </div>-->
  <!--<div class="ir-btn ir-btn--big th-btn-menulevel" (click)="selectMenu(3)">
        <span>{{ 'menus.new-template' | translate  }}</span>
    </div>-->
</div>
